module.exports = __webpack_public_path__ + "static/media/02-banner-01-polanco@2x.b4c7c6a3.jpg";